import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import CsIcon from './components/CsIcon.vue'
import VueProgressBar from 'vue-progressbar'

import { IRole, Role } from './models/role'
import router, { routerHelper } from './router'
import LoginService from './services/LoginService'
import { PermissionService } from 'kuaidong-service'
import { store, loginStore, teacherStore, menuRoleStore } from 'kuaidong-store'
import { HttpUtil, VueUtil, HttpUtilEvent, EnvUtil, logger } from 'kuaidong-lib'

import './assets/icons'
import './assets/style/reset.css'
import './assets/style/base.css'
import './assets/style/element-theme.scss'

Vue.use(ElementUI)
Vue.use(VueProgressBar, {
  color: 'var(--shs-theme-primary)',
  failedColor: '#f56c6c',
  thickness: '3px',
})

router.beforeEach(LoginService.routerBeforeEachHook)

HttpUtil.setWithCredentials()
HttpUtil.on(HttpUtilEvent.StatusCode401, () => LoginService.login())
VueUtil.setARMSConfig({ environment: EnvUtil.isProd() ? 'prod' : 'gray' })

VueUtil.addVConsole()

Vue.component('cs-icon', CsIcon)
Vue.config.productionTip = false
Vue.routerHelper = Vue.prototype.$routerHelper = routerHelper

Vue.mixin({
  computed: {
    $role(): IRole {
      const keys = Object.keys(Role) as [keyof typeof Role]
      const result = {} as any

      keys.forEach((key) => {
        result[key] = loginStore.organization?.role === Role[key]
      })

      return result
    },

    $p() {
      return new PermissionService(
        teacherStore.userRoleInfo,
        teacherStore.teacher,
        menuRoleStore.menuRole
      ).buildPermissions()
    },
  },
})

const v = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

logger.installCodelessTracking(v)
